<!-- eslint-disable vue/multi-word-component-names -->
<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div v-if="saldoPositivo == true" class="vx-row mb-3">
      <div v-if="decoded.consultor" class="vx-col w-3/4" style="display: flex">
        <MeuLink />
      </div>

      <div id="divSaldo" class="vx-col w-1/4" style="display: flex">
        <vx-card
          class="p-3"
          style="
            height: 100% !important;
            display: flex;
            justify-content: center;
          "
        >
          <template slot="no-body">
            <vx-input-group
              style="
                margin-top: auto;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <router-link :to="`extrato`">
                <vs-button
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-dollar-sign"
                  class="w-100"
                  native-type="submit"
                >
                  Saldo : {{ saldo | currency }}</vs-button
                >
              </router-link>

              <!-- <template slot="prepend"> -->
              <!-- <div
                  style="margin-top: auto; height: 100% width"
                  class="prepend-text bg-success"
                >
                  <span>Saldo:</span>
                  <P> {{ saldo | currency }}</P>
                </div> -->
              <!-- </template> -->
            </vx-input-group>
          </template>
        </vx-card>
      </div>
    </div>

    <div v-else class="vx-row mb-3" w="12">
      <div v-if="decoded.consultor" class="vx-col" style="width: 100%">
        <MeuLink />
      </div>
    </div>

    <!-- Permissão de Visualizar os Dados do Dashboard -->
    <div v-if="permissionVisualizarDados">
      <Filtro @filtro="makeFiltro"></Filtro>
      <div class="vx-row">
        <div
          id="divCotacoesGeradas"
          class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <statistics-card-line
            icon="BriefcaseIcon"
            :statistic="analyticsData.cotacoesGeradas.qtd"
            statisticTitle="Propostas Geradas"
            :chartData="analyticsData.cotacoesGeradas"
            type="area"
          ></statistics-card-line>
        </div>
        <div
          id="divVistoriasRealizadas"
          class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <statistics-card-line
            icon="CameraIcon"
            :statistic="analyticsData.vistoriasRealizadas.qtd"
            statisticTitle="Vistorias Realizadas"
            :chartData="analyticsData.vistoriasRealizadas"
            color="success"
            type="area"
          ></statistics-card-line>
        </div>
        <div
          id="divCotacoesRecusadas"
          class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <statistics-card-line
            icon="AlertCircleIcon"
            :statistic="analyticsData.cotacoesRecusadas.qtd"
            statisticTitle="Propostas Recusadas"
            :chartData="analyticsData.cotacoesRecusadas"
            color="danger"
            type="area"
          ></statistics-card-line>
        </div>
        <div
          id="divCotacoesEmAberto"
          class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <statistics-card-line
            icon="ShoppingBagIcon"
            :statistic="analyticsData.cotacoesEmAberto.qtd"
            statisticTitle="Propostas Em Aberto"
            :chartData="analyticsData.cotacoesEmAberto"
            color="warning"
            type="area"
          ></statistics-card-line>
        </div>
      </div>

      <div class="vx-row">
        <!-- LINE CHART -->
        <div
          id="divVendasConcluidas"
          class="vs-con-loading__container vx-col w-full md:w-2/3 mb-base"
        >
          <vx-card :title="`Vendas Concluídas / ${tipoVendas}`">
            <template slot="actions">
              <vs-dropdown>
                <a class="flex items-center" href="#">
                  <feather-icon
                    icon="SettingsIcon"
                    svgClasses="w-6 h-6 text-grey"
                  ></feather-icon>
                </a>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="calculaVendasConcluidas('Valor à Vista')"
                    >Valor à Vista</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="calculaVendasConcluidas('Valor mensal')"
                    >Valor mensal</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </template>

            <div slot="no-body" class="p-6 pb-0">
              <div class="flex">
                <div class="mr-6">
                  <p class="mb-1 font-semibold">Mês Atual</p>
                  <p class="text-3xl text-success">
                    <sup class="text-base mr-1">R$</sup>
                    {{ analyticsData.vendasConcluidas.valorAtual | currency }}
                  </p>
                </div>
                <div>
                  <p class="mb-1 font-semibold">Mês Anterior</p>
                  <p class="text-3xl">
                    <sup class="text-base mr-1">R$</sup>
                    {{
                      analyticsData.vendasConcluidas.valorAnterior | currency
                    }}
                  </p>
                </div>
              </div>
              <vue-apex-charts
                v-if="exibeGraficoVendasConcluidas == true"
                type="line"
                height="266"
                :options="analyticsData.vendasConcluidas.chartOptions"
                :series="analyticsData.vendasConcluidas.series"
              />
            </div>
          </vx-card>
        </div>

        <!-- RADIAL CHART -->
        <div class="vx-col w-full md:w-1/3 mb-base">
          <vx-card title="Taxa de Conversão">
            <template slot="actions">
              <feather-icon
                icon="HelpCircleIcon"
                svgClasses="w-6 h-6 text-grey"
              ></feather-icon>
            </template>

            <!-- CHART -->
            <template slot="no-body">
              <div class="mt-10">
                <vue-apex-charts
                  type="radialBar"
                  height="240"
                  :options="analyticsData.goalOverviewRadialBar.chartOptions"
                  :series="calculaTaxadeConversao()"
                />
              </div>
            </template>

            <!-- DATA -->
            <div class="flex justify-between text-center" slot="no-body-bottom">
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
              >
                <p class="mt-4">Convertidas</p>
                <p class="mb-4 text-3xl font-semibold">
                  {{ analyticsData.vistoriasRealizadas.qtd }}
                </p>
              </div>
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
              >
                <p class="mt-4">Em Aberto</p>
                <p class="mb-4 text-3xl font-semibold">
                  {{ analyticsData.cotacoesEmAberto.qtd }}
                </p>
              </div>
            </div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <!-- CARD 6: Product Orders -->
        <div
          id="divTiposPropostas"
          class="vs-con-loading__container vx-col w-full lg:w-1/3 mb-base"
        >
          <vx-card title="Tipos de Propostas">
            <!-- CARD ACTION -->

            <div slot="no-body">
              <vue-apex-charts
                type="radialBar"
                height="370"
                :options="analyticsData.tiposPropostas.chartOptions"
                :series="analyticsData.tiposPropostas.series"
              />
            </div>

            <ul>
              <li
                v-for="orderData in analyticsData.tiposPropostas.analyticsData"
                :key="orderData.orderType"
                class="flex mb-3 justify-between"
              >
                <span class="flex items-center">
                  <span
                    class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                    :class="`border-${orderData.color}`"
                  ></span>
                  <span class="font-semibold">{{ orderData.orderType }}</span>
                </span>
                <span>{{ orderData.counts }}</span>
              </li>
              <!-- <li><span class="inline-block h-2 w-2 rounded-full mr-2 bg-primary"></span>Finished - 23,043</li> -->
            </ul>
          </vx-card>
        </div>

        <!-- CARD 7: Sales Stats -->
        <div
          id="divConversaoMensal"
          class="vs-con-loading__container vx-col w-full lg:w-1/3 mb-base"
        >
          <vx-card title="Conversão Mensal" subtitle="Últimos 6 meses">
            <template slot="actions">
              <feather-icon
                icon="MoreVerticalIcon"
                svgClasses="w-6 h-6 text-grey"
              ></feather-icon>
            </template>
            <div class="flex">
              <span class="flex items-center">
                <div class="h-3 w-3 rounded-full mr-1 bg-primary"></div>
                <span>Total</span>
              </span>
              <span class="flex items-center ml-4">
                <div class="h-3 w-3 rounded-full mr-1 bg-success"></div>
                <span>Vistorias</span>
              </span>
            </div>
            <div slot="no-body-bottom">
              <vue-apex-charts
                type="radar"
                height="400"
                :options="analyticsData.conversaoMensal.chartOptions"
                :series="analyticsData.conversaoMensal.series"
              />
            </div>
          </vx-card>
        </div>

        <div
          id="divOrigem"
          class="vs-con-loading__container vx-col w-full lg:w-1/3 lg:mt-0 mt-base"
        >
          <vx-card title="Origem">
            <!-- SLOT = ACTIONS -->

            <div slot="no-body">
              <!-- CHART -->
              <vue-apex-charts
                type="pie"
                height="345"
                class="mt-2"
                :options="analyticsData.origem.chartOptions"
                :series="analyticsData.origem.series"
              />

              <!-- CHART DATA -->
              <ul class="mb-1">
                <li
                  v-for="customerData in analyticsData.origem.analyticsData"
                  :key="customerData.customerType"
                  class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
                >
                  <span class="flex items-center">
                    <span
                      class="inline-block h-3 w-3 rounded-full mr-2"
                      :class="`bg-${customerData.color}`"
                    ></span>
                    <span class="font-semibold">{{
                      customerData.customerType
                    }}</span>
                  </span>
                  <span>{{ customerData.counts }}</span>
                </li>
              </ul>
            </div>
          </vx-card>
        </div>
      </div>
      <!--ModalNotificacao :dadosVeiculosEmpresaAntiga="dadosModal" /-->
    </div>

    <!-- Sem Permissão para visualizar os Dados do Dashboard -->
    <div v-else>
      <LogoDashboard />
    </div>

    <ModalNotificationPagamentoInconsistentes />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import analyticsData from './../../ui-elements/card/analyticsData.js';
import service from './../../services';
import ability from './../../services/ability';
import Filtro from './../filtros/FiltroDashBoard';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import MeuLink from './component/meu-link.vue';
import LogoDashboard from './component/logo-dashboard.vue';
import ModalNotificacao from '../modais/ModalVeiculosEmpresaAntiga.vue';
import ModalNotificationPagamentoInconsistentes from '../menu/financeiro/Pagamentos-Inconsistentes/ModalNotification.vue';

export default {
  data() {
    return {
      decoded: null,
      filtro: null,
      objSend: {},
      tipoVendas: 'Valor à Vista',
      analyticsData: analyticsData,
      selected: [],
      usuarios_regionais: [],
      controllerGeral: 'Usuario',
      itens: [],
      regionais: [],
      regionaisUsuario: [],
      idRegionais: [],
      regionaisUsuarios: [],
      regionalDefault: [],
      chatMsgInput: '',
      contentImg1: 'content-img-1.jpg',
      profileUser1: 'avatar-s-18.png',
      profileUser2: 'avatar-s-1.png',
      profileUser3: 'avatar-s-12.png',
      overlayImg2: 'card-image-5.jpg',
      exibeGraficoVendasConcluidas: false,
      saldo: 0,
      saldoPositivo: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      chatMsg: [
        {
          senderImg: 'avatar-s-2.png',
          msg: 'Cake sesame snaps cupcake gingerbread',
          isSent: true,
        },
        {
          senderImg: 'avatar-s-5.png',
          msg: 'Apple pie pie jujubes chupa chups muffin',
          isSent: false,
        },
        { senderImg: 'avatar-s-2.png', msg: 'Chocolate cake', isSent: true },
        {
          senderImg: 'avatar-s-5.png',
          msg: 'Donut sweet pie oat cake dragée fruitcake',
          isSent: false,
        },
        {
          senderImg: 'avatar-s-2.png',
          msg: 'Liquorice chocolate bar jelly beans icing',
          isSent: true,
        },
        {
          senderImg: 'avatar-s-5.png',
          msg: 'Powder toffee tootsie roll macaroon cupcake.',
          isSent: false,
        },
        {
          senderImg: 'avatar-s-2.png',
          msg: 'Apple pie oat cake brownie cotton candy cupcake chocolate bar dessert.',
          isSent: true,
        },
        {
          senderImg: 'avatar-s-5.png',
          msg: 'Biscuit cake jujubes carrot cake topping sweet cake.',
          isSent: false,
        },
      ],
      permissionVisualizarDados: this.$can('Visualizar Dados', 'Dashboard'),
      dadosModal: {},
    };
  },
  methods: {
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDadosCotacoesGeradas();
      this.buscaDadosVistoriasRealizadas();
      this.buscaDadosCotacoesRecusadas();
      this.buscaDadosCotacoesEmAberto();
      // this.buscaSaldo(); // não excluir será utilizado no futuro
      this.buscaPorTipo();
      this.buscaConversaoMensal();
      this.calculaVendasConcluidas(this.tipoVendas);
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
      this.id_empresa = this.decoded.id_empresa;
    },
    makeFiltro(filtro) {
      this.filtro = filtro;
      this.filtraGeral();
    },
    dataInicio() {
      // eslint-disable-next-line no-undef
      return primeiroDia;
    },
    preparaFiltro() {
      var permissoes = ability.getPermission().$;

      var arrayCarteiraIndividual = permissoes.filter(
        (x) =>
          x.subject == 'Associados' &&
          x.action == 'Leitura Carteira Individual',
      );
      var arrayCarteiraRegional = permissoes.filter(
        (x) =>
          x.subject == 'Associados' && x.action == 'Leitura Carteira Regional',
      );
      var arrayCarteiraGeral = permissoes.filter(
        (x) =>
          x.subject == 'Associados' && x.action == 'Leitura Carteira Completa',
      );
      var isCarteiraIndividual =
        arrayCarteiraIndividual.length > 0 ? true : false;
      var isCarteiraRegional = arrayCarteiraRegional.length > 0 ? true : false;
      // eslint-disable-next-line no-unused-vars
      var isCarteiraGeral = arrayCarteiraGeral.length > 0 ? true : false;

      this.objSend = {};
      if (this.filtro) {
        this.objSend = { ...this.filtro };
        this.objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        this.objSend.dataFinal = moment(this.filtro.dataFinal).format(
          'YYYY-MM-DD',
        );
      } else {
        var date = new Date();
        var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
        var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.objSend.dataInicial = moment(primeiroDia).format('YYYY-MM-DD');
        this.objSend.dataFinal = moment(ultimoDia).format('YYYY-MM-DD');
      }
      if (this.filtro) {
        if (this.filtro.regional) {
          var regionaisFiltro = this.filtro.regional.map((item) => item.id);
          this.objSend.regional = regionaisFiltro;
        } else {
          this.objSend.regional = this.idRegionais;
        }
      } else {
        this.objSend.regional = this.idRegionais;
      }

      if (isCarteiraIndividual == true) {
        this.objSend.consultor = [{ id: this.decoded.id_usuario }];
      }
      // if (isCarteiraRegional == true) {
      //   this.objSend.regional = this.decoded.id_regional;
      // }
    },
    calculaTaxadeConversao() {
      var total =
        (analyticsData.vistoriasRealizadas.qtd * 100) /
        analyticsData.cotacoesGeradas.qtd;
      return [total.toFixed()];
    },
    irParaExtrato() {},
    buscaDadosCotacoesGeradas() {
      this.$vs.loading({
        container: '#divCotacoesGeradas',
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = 'CotacoesGeradas';
      objSend.id_regionais = this.idRegionais;

      service.post('Relatorios', 'numerosGerais', objSend).then((res) => {
        analyticsData.cotacoesGeradas.qtd = res.data.qtd;
        analyticsData.cotacoesGeradas.series[0].data = res.data.dados;
        this.$vs.loading.close('#divCotacoesGeradas > .con-vs-loading');
      });
    },

    buscaDadosVistoriasRealizadas() {
      this.$vs.loading({
        container: '#divVistoriasRealizadas',
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = 'VistoriasRealizadas';
      objSend.id_regionais = this.idRegionais;
      service.post('Relatorios', 'numerosGerais', objSend).then((res) => {
        analyticsData.vistoriasRealizadas.qtd = res.data.qtd;
        analyticsData.vistoriasRealizadas.series[0].data = res.data.dados;
        this.$vs.loading.close('#divVistoriasRealizadas > .con-vs-loading');
      });
    },
    buscaDadosCotacoesRecusadas() {
      this.$vs.loading({
        container: '#divCotacoesRecusadas',
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = 'CotacoesRecusadas';
      objSend.id_regionais = this.idRegionais;
      service.post('Relatorios', 'numerosGerais', objSend).then((res) => {
        analyticsData.cotacoesRecusadas.qtd = res.data.qtd;
        analyticsData.cotacoesRecusadas.series[0].data = res.data.dados;
        this.$vs.loading.close('#divCotacoesRecusadas > .con-vs-loading');
      });
    },
    buscaDadosCotacoesEmAberto() {
      this.$vs.loading({
        container: '#divCotacoesEmAberto',
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = 'CotacoesEmAberto';
      objSend.id_regionais = this.idRegionais;
      service.post('Relatorios', 'numerosGerais', objSend).then((res) => {
        analyticsData.cotacoesEmAberto.qtd = res.data.qtd;
        analyticsData.cotacoesEmAberto.series[0].data = res.data.dados;
        this.$vs.loading.close('#divCotacoesEmAberto > .con-vs-loading');
      });
    },
    async buscaDadosRegionais() {
      try {
        this.$vs.loading();
        const res = await service.post(
          'Usuario',
          `find/${this.id_usuario}`,
          {},
        );

        this.$vs.loading.close();
        res.data.forEach((element) => {
          if (element.idUsuario == this.id_usuario) {
            if (element.usuarios_regionais.length > 0) {
              this.usuarios_regionais = element.usuarios_regionais;
              this.usuarios_regionais.forEach((elementSel) => {
                this.regionaisUsuario.push({
                  id: elementSel.id_regional,
                  label: elementSel.nome,
                });
              });
              this.regionais = this.regionaisUsuario.concat(
                this.regionalDefault,
              );
              this.idRegionais = this.regionais.map((item) => item.id);
            } else {
              var usuarios_regionais = element.Usuarios_Regional;
              this.regionais.push({
                id: usuarios_regionais.idRegional,
                label: usuarios_regionais.nome,
              });
              this.idRegionais = this.regionais.map((item) => item.id);
            }
          }
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca regionais`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    async buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      try {
        const res = await service.getAll(
          'g',
          {},
          `${model}/list/idEmpresa/${this.id_empresa}`,
        );

        res.data.forEach((element) => {
          if (element[campoPK] == this.decoded.id_regional) {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          }
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca regional padrão`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    buscaConversaoMensal() {
      this.$vs.loading({
        container: '#divConversaoMensal',
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.id_regionais = this.idRegionais;
      service.post('Relatorios', 'conversaoMensal', objSend).then((res) => {
        var arrTotal = [];
        var arrVistorias = [];
        var arrLabel = [];
        res.data.forEach((element) => {
          arrTotal.push(element.Total);
          arrVistorias.push(element.Convertidas);
          arrLabel.push(element.nomeMes);
        });
        analyticsData.conversaoMensal.series[0].data = arrTotal;
        analyticsData.conversaoMensal.series[1].data = arrVistorias;
        analyticsData.conversaoMensal.chartOptions.labels = arrLabel;

        this.$vs.loading.close('#divConversaoMensal > .con-vs-loading');
      });
    },
    buscaPorTipo() {
      this.$vs.loading({
        container: '#divTiposPropostas',
        scale: 0.6,
      });

      this.$vs.loading({
        container: '#divOrigem',
        scale: 0.6,
      });

      var objSend = { ...this.objSend };

      objSend.id_regionais = this.idRegionais;
      service.post('Relatorios', 'vendasPorTipo', objSend).then((res) => {
        /************TIPOS**************/
        var totalTipo = 0;
        var seriesTipos = [0, 0, 0, 0];
        analyticsData.tiposPropostas.analyticsData.forEach((el) => {
          el.counts = 0;
        });
        res.data.tipo.forEach((element) => {
          var aux = analyticsData.tiposPropostas.analyticsData.find(
            (x) => x.orderType == element.tipoProposta,
          );
          if (aux) {
            aux.counts = element.qtd;
            totalTipo = totalTipo + element.qtd;
            var percentual = (element.qtd * 100) / element.total;
          }

          if (element.tipoProposta == 'Adesão') {
            seriesTipos[0] = parseInt(percentual.toFixed());
          }
          if (element.tipoProposta == 'Inclusão') {
            seriesTipos[1] = parseInt(percentual.toFixed());
          }
          if (element.tipoProposta == 'Reativação') {
            seriesTipos[2] = parseInt(percentual.toFixed());
          }
          if (element.tipoProposta == 'Substituição') {
            seriesTipos[3] = parseInt(percentual.toFixed());
          }
        });
        analyticsData.tiposPropostas.series = seriesTipos;
        analyticsData.tiposPropostas.chartOptions.plotOptions.radialBar.dataLabels.total.formatter =
          this.somaTotalTipo();

        /************ORIGEM**************/
        var arrayAux = [];
        for (
          let index = 0;
          index < analyticsData.origem.analyticsData.length;
          index++
        ) {
          var element = analyticsData.origem.analyticsData[index];
          var aux = res.data.origem.filter(
            (x) => x.origem == element.customerType,
          );
          if (aux.length > 0) element.counts = aux[0].qtd;
          else element.counts = 0;
          arrayAux[index] = element.counts;
        }
        analyticsData.origem.series = arrayAux;
        this.$vs.loading.close('#divTiposPropostas > .con-vs-loading');
        this.$vs.loading.close('#divOrigem > .con-vs-loading');
      });
    },
    somaTotalTipo() {
      var total = 0;
      analyticsData.tiposPropostas.analyticsData.forEach((el) => {
        total = total + el.counts;
      });
      return total;
    },
    calculaVendasConcluidas(tipo) {
      this.tipoVendas = tipo;

      this.$vs.loading({
        container: '#divVendasConcluidas',
        scale: 0.6,
      });

      const objSend = { ...this.objSend };

      objSend.tipo = this.tipoVendas;
      objSend.id_regionais = this.idRegionais;

      this.exibeGraficoVendasConcluidas = false;

      service.post('Relatorios', 'vendasConcluidas', objSend).then((res) => {
        analyticsData.vendasConcluidas.valorAtual = res.data.atual[3].valor;
        analyticsData.vendasConcluidas.valorAnterior =
          res.data.anterior[3].valor;
        analyticsData.vendasConcluidas.series[0].data = [
          res.data.atual[0].valor,
          res.data.atual[1].valor,
          res.data.atual[2].valor,
          res.data.atual[3].valor,
        ];
        analyticsData.vendasConcluidas.series[1].data = [
          res.data.anterior[0].valor,
          res.data.anterior[1].valor,
          res.data.anterior[2].valor,
          res.data.anterior[3].valor,
        ];

        this.$vs.loading.close('#divVendasConcluidas > .con-vs-loading');
        this.exibeGraficoVendasConcluidas = true;
      });
    },
    buscaSaldo() {
      let objSend = {};
      objSend.idUsuario = this.decoded.id_usuario;
      objSend.idEmpresa = this.decoded.id_empresa;

      service
        .post('extrato', 'list-extrato', objSend)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.saldo) {
              this.saldo = element.saldo;
              if (this.saldo >= 0) {
                this.saldoPositivo = true;
                this.$vs.loading.close('#divSaldo > .con-vs-loading');
              }
            }
          });
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel listar os extratos',
            color: 'danger',
          });
        });
    },
    openModalNotificacao(id, acao) {
      const obj = { id, acao };
      this.dadosModal = obj;
    },
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    Filtro,
    MeuLink,
    LogoDashboard,
    ModalNotificacao,
    ModalNotificationPagamentoInconsistentes,
  },
  async created() {
    this.getDecoded();

    if (!this.permissionVisualizarDados) {
      return;
    }

    await this.buscaDadosRegionalDefault(
      'regionais',
      'regionalDefault',
      'nome',
      'idRegional',
    );
    await this.buscaDadosRegionais(
      'regionais',
      'regionais',
      'nome',
      'idRegional',
    );

    this.filtraGeral();
  },
  mounted() {
    /* if ([118, 119, 120].includes(this.id_empresa))
      this.openModalNotificacao(null, 'notificacaoDashboard');*/
  },
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
<style>
.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  height: 100%;
}
.vs-con-loading__container .con-vs-loading {
  z-index: 50;
}
</style>
